module.exports = new __parcel__URL__("match-browser.cf8cedaf.svg").toString();